import { render, staticRenderFns } from "./EditOffertaLavoro.vue?vue&type=template&id=77f2362a&scoped=true&"
import script from "./EditOffertaLavoro.vue?vue&type=script&lang=ts&"
export * from "./EditOffertaLavoro.vue?vue&type=script&lang=ts&"
import style0 from "./EditOffertaLavoro.vue?vue&type=style&index=0&id=77f2362a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f2362a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VBtn,VCardText,VCardTitle,VCol,VForm,VIcon,VRow,VTextField,VTextarea})
